var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xy-center flex-y",staticStyle:{"width":"100%","height":"100%"}},[_c('img',{staticStyle:{"width":"196px","height":"214px"},attrs:{"src":"https://oss.yf-gz.cn/file/1735553285863_88ff74e13bb7d44b5e055205c03add69.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26128fcc","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/zzcbpmDashboard/common/black-empty.vue
// module id = null
// module chunks = 